export const getServerDateNow = () => +localStorage.getItem("DateNow");
